export enum IncidentAction {
  JUNK = "junk",
  SAFE = "safe",
}

export type BatchStatus = "success" | "inProgress" | "error" | "notFound";

export type BatchDTO = {
  error?: { message: string; statusCode: number };
  stats?: {
    total: number;
    failed: number;
    success: number;
    completed: boolean;
    unexpected: number;
  };
  uuid: string;
};

export type MultiActionBatchStatusDTO = {
  batches: BatchDTO[];
};

export type MultiActionBatchStatus = {
  id: string;
  stats: {
    total: number;
    failed: number;
    success: number;
    completed: boolean;
  };
  status: BatchStatus;
};
